module.exports = __webpack_public_path__ + "resources/img/img_secureguard_am3.a067ed36c3efff4e696343eebc6a4c0d.png";